import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical, Trash2 } from "lucide-react";
import type React from "react";

export function SortableItem({
	id,
	children,
	onDelete,
}: {
	id: string;
	children: React.ReactNode;
	onDelete: () => void;
}) {
	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		transition,
		isDragging,
	} = useSortable({ id });

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		zIndex: isDragging ? 10 : 1,
		opacity: isDragging ? 0.6 : 1,
	};

	return (
		<div ref={setNodeRef} style={style} className="card-edit sortable-card">
			<div className="card-controls">
				<div
					{...attributes}
					{...listeners}
					className="drag-handle"
					title="Drag to reorder"
				>
					<GripVertical size={16} />
				</div>
				<button
					title="Remove"
					type="button"
					onClick={onDelete}
					className="btn-delete-static"
				>
					<Trash2 size={16} />
				</button>
			</div>
			{children}
		</div>
	);
}
